import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { DatetimePicker, Popup, Dialog, Toast, Loading, Field, Picker, Uploader, Search, IndexBar, IndexAnchor, Cell, Sticky, Swipe, SwipeItem, Overlay, List, Button, PullRefresh,Form, ImagePreview, ActionSheet} from 'vant'
import dayjs from 'dayjs'
// import toast from '@/components/Toast/toast.js'
import {isInnerYueyue,initSysConfig} from './utils/tool'
import "amfe-flexible";
import 'vant/lib/index.css'
import '@/assets/common.css'

// CSP、monitor等
initSysConfig()

let isInnerApp = isInnerYueyue()
sessionStorage.setItem('isInnerApp', isInnerApp)
Vue.prototype.$dayjs = dayjs
Vue.prototype.$toast = Toast
Vue.config.productionTip = false
Vue.use(Toast)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Field)
Vue.use(Picker)
Vue.use(Loading)
Vue.use(Uploader);
Vue.use(List);
Vue.use(Button);
Vue.use(Cell);
Vue.use(PullRefresh);
Vue.use(Search);
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Sticky);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Overlay)
Vue.use(Form)
Vue.use(ActionSheet)
Vue.use(ImagePreview);
Vue.prototype.$isInnerApp = isInnerYueyue;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
